module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~#callme.Site_Page":{"widgets.verifiedcallWidget.widget":[{"value":"VerifiedCall","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~#callme.Site_Page","_fox_":1}],"widgets.verifiedcallWidget.embed.container":[{"value":".verifiedcall-widget","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~#callme.Site_Page","_fox_":1}],"widgets.verifiedcallWidget.style":[{"value":"page","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~#callme.Site_Page","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/verifiedcall.js
// module id = 715
// module chunks = 4